import axios from 'axios'

export default {
	namespaced: true,
	state: {
		permisos: {}
	},
	getters: {
		permisos: (state) => {
			return state.permisos
		}
	},
	mutations: {
		setPermisos (state, payload) {
			state.permisos = payload.permisos
		}
	},
	actions: {
		getPermisos (context) {
			axios.get('/core/php/api/perfil/get-todos-permisos.php')
				.then(res => {
					context.commit('setPermisos', res.data)
				})
				.catch(e => {
					if (e.message && e.message.code === 423) {
						return
					}
					this.commit('toast/danger', {
						titulo: 'Error obteniendo los permisos',
						mensaje: (e.response && e.response.data && e.response.data.error) ? e.response.data.error : ''
					})
				})
		}
	}
}



// WEBPACK FOOTER //
// ./src/modulos/core/vue/store/permisos.js